//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, from as _observableFrom, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export class SwaggerBase {
  public static enableBasicAuth = false;
  public static basicAuthLogin = "";
  public static basicAuthPassword = "";

  protected constructor() {
  }

  protected transformOptions(options: any): Promise<any> {
    if (SwaggerBase.enableBasicAuth) {
      const encodedCredentials = btoa(`${SwaggerBase.basicAuthLogin}:${SwaggerBase.basicAuthPassword}`);
      options.headers = options.headers.append('authorization', `Basic ${encodedCredentials}`);
    }

    return Promise.resolve(options);
  }
}

@Injectable({
    providedIn: 'root'
})
export class Self_registrationClient extends SwaggerBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "/";
    }

    /**
     * @param languageId language ID for the new subscriber / user of the self-registration.
     * @param body self registration input data.
     * @return Ok
     */
    requestSelfRegistration(languageId: number, body: SubscriberOnboardingInput): Observable<SubscriberOnboarding> {
        let url_ = this.baseUrl + "/self-registration/request/{languageId}";
        if (languageId === undefined || languageId === null)
            throw new Error("The parameter 'languageId' must be defined.");
        url_ = url_.replace("{languageId}", encodeURIComponent("" + languageId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRequestSelfRegistration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestSelfRegistration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriberOnboarding>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriberOnboarding>;
        }));
    }

    protected processRequestSelfRegistration(response: HttpResponseBase): Observable<SubscriberOnboarding> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriberOnboarding.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OnboardingClient extends SwaggerBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "/";
    }

    /**
     * @return Ok
     */
    getSubscriberByOnboardingToken(token: string): Observable<SubscriberOnboarding> {
        let url_ = this.baseUrl + "/onboarding/subscriber/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSubscriberByOnboardingToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscriberByOnboardingToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriberOnboarding>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriberOnboarding>;
        }));
    }

    protected processGetSubscriberByOnboardingToken(response: HttpResponseBase): Observable<SubscriberOnboarding> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriberOnboarding.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Ok
     */
    getUserByOnboardingToken(token: string): Observable<User> {
        let url_ = this.baseUrl + "/onboarding/user/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserByOnboardingToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserByOnboardingToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<User>;
                }
            } else
                return _observableThrow(response_) as any as Observable<User>;
        }));
    }

    protected processGetUserByOnboardingToken(response: HttpResponseBase): Observable<User> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = User.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Ok
     */
    checkVatNumber(vatnumber: string): Observable<EntityVatCheck> {
        let url_ = this.baseUrl + "/onboarding/vat/{vatnumber}";
        if (vatnumber === undefined || vatnumber === null)
            throw new Error("The parameter 'vatnumber' must be defined.");
        url_ = url_.replace("{vatnumber}", encodeURIComponent("" + vatnumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckVatNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckVatNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityVatCheck>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityVatCheck>;
        }));
    }

    protected processCheckVatNumber(response: HttpResponseBase): Observable<EntityVatCheck> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EntityVatCheck.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Ok
     */
    completeSubscriberOnboarding(body: CompleteSubscriberOnboarding): Observable<Subscriber> {
        let url_ = this.baseUrl + "/onboarding/subscriber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCompleteSubscriberOnboarding(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteSubscriberOnboarding(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Subscriber>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Subscriber>;
        }));
    }

    protected processCompleteSubscriberOnboarding(response: HttpResponseBase): Observable<Subscriber> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Subscriber.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Ok
     */
    getUserPasswordResetInformation(token: string): Observable<Anonymous> {
        let url_ = this.baseUrl + "/onboarding/user/password-reset/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserPasswordResetInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPasswordResetInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous>;
        }));
    }

    protected processGetUserPasswordResetInformation(response: HttpResponseBase): Observable<Anonymous> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Anonymous.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Ok
     */
    completePasswordReset(body: PasswordResetBody): Observable<User> {
        let url_ = this.baseUrl + "/onboarding/user/password-reset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCompletePasswordReset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompletePasswordReset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<User>;
                }
            } else
                return _observableThrow(response_) as any as Observable<User>;
        }));
    }

    protected processCompletePasswordReset(response: HttpResponseBase): Observable<User> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = User.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Ok
     */
    completeUserOnboarding(body: CompleteUserOnboardingBody): Observable<User> {
        let url_ = this.baseUrl + "/onboarding/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCompleteUserOnboarding(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteUserOnboarding(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<User>;
                }
            } else
                return _observableThrow(response_) as any as Observable<User>;
        }));
    }

    protected processCompleteUserOnboarding(response: HttpResponseBase): Observable<User> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = User.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class GuestClient extends SwaggerBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "/";
    }

    /**
     * @return Ok
     */
    getInvoice(token: string): Observable<GuestInvoice> {
        let url_ = this.baseUrl + "/guest/invoice/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuestInvoice>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuestInvoice>;
        }));
    }

    protected processGetInvoice(response: HttpResponseBase): Observable<GuestInvoice> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GuestInvoice.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Ok
     */
    getCreditnote(token: string): Observable<GuestCreditnote> {
        let url_ = this.baseUrl + "/guest/creditnote/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCreditnote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCreditnote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuestCreditnote>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuestCreditnote>;
        }));
    }

    protected processGetCreditnote(response: HttpResponseBase): Observable<GuestCreditnote> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GuestCreditnote.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Ok
     */
    getOrder(token: string): Observable<GuestOrder> {
        let url_ = this.baseUrl + "/guest/order/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuestOrder>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuestOrder>;
        }));
    }

    protected processGetOrder(response: HttpResponseBase): Observable<GuestOrder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GuestOrder.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Ok
     */
    getQuote(token: string): Observable<GuestQuote> {
        let url_ = this.baseUrl + "/guest/quote/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetQuote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuestQuote>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuestQuote>;
        }));
    }

    protected processGetQuote(response: HttpResponseBase): Observable<GuestQuote> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GuestQuote.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Ok
     */
    acceptQuote(quoteId: number, body: Body): Observable<Quote> {
        let url_ = this.baseUrl + "/guest/quote/{quoteId}/accept";
        if (quoteId === undefined || quoteId === null)
            throw new Error("The parameter 'quoteId' must be defined.");
        url_ = url_.replace("{quoteId}", encodeURIComponent("" + quoteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAcceptQuote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptQuote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Quote>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Quote>;
        }));
    }

    protected processAcceptQuote(response: HttpResponseBase): Observable<Quote> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Quote.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Ok
     */
    declineQuote(quoteId: number, body: Body2): Observable<Quote> {
        let url_ = this.baseUrl + "/guest/quote/{quoteId}/decline";
        if (quoteId === undefined || quoteId === null)
            throw new Error("The parameter 'quoteId' must be defined.");
        url_ = url_.replace("{quoteId}", encodeURIComponent("" + quoteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeclineQuote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeclineQuote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Quote>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Quote>;
        }));
    }

    protected processDeclineQuote(response: HttpResponseBase): Observable<Quote> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Quote.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DownloadClient extends SwaggerBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "/";
    }

    /**
     * @param token The download token of the ledger export.
     * @return Ok
     */
    getLedgerExportBase64(token: string): Observable<string> {
        let url_ = this.baseUrl + "/download/ledger-export/download/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLedgerExportBase64(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLedgerExportBase64(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetLedgerExportBase64(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param token The download token of the ledger export.
     * @return Ok
     */
    getLedgerExport(token: string): Observable<LedgerExport> {
        let url_ = this.baseUrl + "/download/ledger-export/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLedgerExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLedgerExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LedgerExport>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LedgerExport>;
        }));
    }

    protected processGetLedgerExport(response: HttpResponseBase): Observable<LedgerExport> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LedgerExport.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AuthenticationClient extends SwaggerBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "/";
    }

    /**
     * @return Ok
     */
    requestIp(): Observable<any> {
        let url_ = this.baseUrl + "/auth/ip";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRequestIp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestIp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processRequestIp(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param subscriberId ID of the subscriber connected to the token
     * @return Ok
     */
    requestTokenByBasicAuth(subscriberId: number): Observable<Token> {
        let url_ = this.baseUrl + "/auth/client/{subscriberId}/token";
        if (subscriberId === undefined || subscriberId === null)
            throw new Error("The parameter 'subscriberId' must be defined.");
        url_ = url_.replace("{subscriberId}", encodeURIComponent("" + subscriberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRequestTokenByBasicAuth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestTokenByBasicAuth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Token>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Token>;
        }));
    }

    protected processRequestTokenByBasicAuth(response: HttpResponseBase): Observable<Token> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Token.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Ok
     */
    requestTokenByApikey(): Observable<Token> {
        let url_ = this.baseUrl + "/auth/client/api";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRequestTokenByApikey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestTokenByApikey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Token>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Token>;
        }));
    }

    protected processRequestTokenByApikey(response: HttpResponseBase): Observable<Token> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Token.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Ok
     */
    requestPartnerTokenByBasicAuth(): Observable<Token> {
        let url_ = this.baseUrl + "/auth/partner/token";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRequestPartnerTokenByBasicAuth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestPartnerTokenByBasicAuth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Token>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Token>;
        }));
    }

    protected processRequestPartnerTokenByBasicAuth(response: HttpResponseBase): Observable<Token> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Token.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param subscriberId ID of the subscriber connected to the token
     * @return Ok
     */
    requestSubscriberTokenByAccountant(subscriberId: number): Observable<Token> {
        let url_ = this.baseUrl + "/auth/accountant/client/{subscriberId}/token";
        if (subscriberId === undefined || subscriberId === null)
            throw new Error("The parameter 'subscriberId' must be defined.");
        url_ = url_.replace("{subscriberId}", encodeURIComponent("" + subscriberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRequestSubscriberTokenByAccountant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestSubscriberTokenByAccountant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Token>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Token>;
        }));
    }

    protected processRequestSubscriberTokenByAccountant(response: HttpResponseBase): Observable<Token> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Token.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param subscriberId ID of the subscriber connected to the token
     * @return Ok
     */
    requestSubscriberTokenBySupport(subscriberId: number): Observable<Token> {
        let url_ = this.baseUrl + "/auth/support/client/{subscriberId}/token";
        if (subscriberId === undefined || subscriberId === null)
            throw new Error("The parameter 'subscriberId' must be defined.");
        url_ = url_.replace("{subscriberId}", encodeURIComponent("" + subscriberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRequestSubscriberTokenBySupport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestSubscriberTokenBySupport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Token>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Token>;
        }));
    }

    protected processRequestSubscriberTokenBySupport(response: HttpResponseBase): Observable<Token> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Token.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Ok
     */
    validateToken(token: string): Observable<Token> {
        let url_ = this.baseUrl + "/auth/client/{token}/validate";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processValidateToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Token>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Token>;
        }));
    }

    protected processValidateToken(response: HttpResponseBase): Observable<Token> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Token.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Ok
     */
    validatePartnerToken(token: string): Observable<Token> {
        let url_ = this.baseUrl + "/auth/partner/{token}/validate";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processValidatePartnerToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidatePartnerToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Token>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Token>;
        }));
    }

    protected processValidatePartnerToken(response: HttpResponseBase): Observable<Token> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Token.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Ok
     */
    renewToken(token: string): Observable<Token> {
        let url_ = this.baseUrl + "/auth/client/{token}/renew";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRenewToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenewToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Token>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Token>;
        }));
    }

    protected processRenewToken(response: HttpResponseBase): Observable<Token> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Token.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Ok
     */
    renewPartnerToken(token: string): Observable<Token> {
        let url_ = this.baseUrl + "/auth/partner/{token}/renew";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRenewPartnerToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenewPartnerToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Token>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Token>;
        }));
    }

    protected processRenewPartnerToken(response: HttpResponseBase): Observable<Token> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Token.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Ok
     */
    listSubscribersByLogin(login: string): Observable<Subscriber[]> {
        let url_ = this.baseUrl + "/auth/client/{login}/subscribers";
        if (login === undefined || login === null)
            throw new Error("The parameter 'login' must be defined.");
        url_ = url_.replace("{login}", encodeURIComponent("" + login));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processListSubscribersByLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListSubscribersByLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Subscriber[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Subscriber[]>;
        }));
    }

    protected processListSubscribersByLogin(response: HttpResponseBase): Observable<Subscriber[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Subscriber.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Ok
     */
    getDefaultSubscriberByLogin(login: string): Observable<number> {
        let url_ = this.baseUrl + "/auth/client/{login}/default-subscriber";
        if (login === undefined || login === null)
            throw new Error("The parameter 'login' must be defined.");
        url_ = url_.replace("{login}", encodeURIComponent("" + login));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDefaultSubscriberByLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultSubscriberByLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetDefaultSubscriberByLogin(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export enum EmailStatusEnum {
    _1 = "1",
    _2 = "2",
    _3 = "3",
    _4 = "4",
    _5 = "5",
}

export enum EmailPriorityEnum {
    _1 = "1",
    _2 = "2",
    _3 = "3",
}

export class Email implements IEmail {
    id!: number;
    subscriber_id!: number;
    tbl_obj_id!: number;
    user_id!: number;
    subject!: string;
    body!: string;
    status!: number;
    priority!: number;
    send!: Date;
    result!: string;
    created!: Date;
    updated!: Date;
    firstRead!: Date;
    lastRead!: Date;
    readCount!: number;
    termsAndConditions!: number;
    whitelabel!: string;
    tableId!: number;

    constructor(data?: IEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subscriber_id = _data["subscriber_id"];
            this.tbl_obj_id = _data["tbl_obj_id"];
            this.user_id = _data["user_id"];
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.status = _data["status"];
            this.priority = _data["priority"];
            this.send = _data["send"] ? new Date(_data["send"].toString()) : <any>undefined;
            this.result = _data["result"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
            this.firstRead = _data["firstRead"] ? new Date(_data["firstRead"].toString()) : <any>undefined;
            this.lastRead = _data["lastRead"] ? new Date(_data["lastRead"].toString()) : <any>undefined;
            this.readCount = _data["readCount"];
            this.termsAndConditions = _data["termsAndConditions"];
            this.whitelabel = _data["whitelabel"];
            this.tableId = _data["tableId"];
        }
    }

    static fromJS(data: any): Email {
        data = typeof data === 'object' ? data : {};
        let result = new Email();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subscriber_id"] = this.subscriber_id;
        data["tbl_obj_id"] = this.tbl_obj_id;
        data["user_id"] = this.user_id;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["status"] = this.status;
        data["priority"] = this.priority;
        data["send"] = this.send ? this.send.toISOString() : <any>undefined;
        data["result"] = this.result;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["firstRead"] = this.firstRead ? this.firstRead.toISOString() : <any>undefined;
        data["lastRead"] = this.lastRead ? this.lastRead.toISOString() : <any>undefined;
        data["readCount"] = this.readCount;
        data["termsAndConditions"] = this.termsAndConditions;
        data["whitelabel"] = this.whitelabel;
        data["tableId"] = this.tableId;
        return data;
    }
}

export interface IEmail {
    id: number;
    subscriber_id: number;
    tbl_obj_id: number;
    user_id: number;
    subject: string;
    body: string;
    status: number;
    priority: number;
    send: Date;
    result: string;
    created: Date;
    updated: Date;
    firstRead: Date;
    lastRead: Date;
    readCount: number;
    termsAndConditions: number;
    whitelabel: string;
    tableId: number;
}

export enum HowDoYouKnowUsEnum {
    _1 = "1",
    _2 = "2",
    _3 = "3",
    _4 = "4",
    _5 = "5",
    _6 = "6",
}

export class SubscriberOnboarding implements ISubscriberOnboarding {
    id!: number;
    name!: string;
    email!: string;
    date!: Date;
    expireDate!: Date;
    token!: string;
    used!: boolean;
    usedDate!: Date;
    resellerId!: number;
    accountancyId!: number;
    howDoYouKnowUs!: number;
    howDoYouKnowUsExtra!: string;
    referral!: string;
    subscriberId!: number;

    constructor(data?: ISubscriberOnboarding) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.expireDate = _data["expireDate"] ? new Date(_data["expireDate"].toString()) : <any>undefined;
            this.token = _data["token"];
            this.used = _data["used"];
            this.usedDate = _data["usedDate"] ? new Date(_data["usedDate"].toString()) : <any>undefined;
            this.resellerId = _data["resellerId"];
            this.accountancyId = _data["accountancyId"];
            this.howDoYouKnowUs = _data["howDoYouKnowUs"];
            this.howDoYouKnowUsExtra = _data["howDoYouKnowUsExtra"];
            this.referral = _data["referral"];
            this.subscriberId = _data["subscriberId"];
        }
    }

    static fromJS(data: any): SubscriberOnboarding {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriberOnboarding();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["token"] = this.token;
        data["used"] = this.used;
        data["usedDate"] = this.usedDate ? this.usedDate.toISOString() : <any>undefined;
        data["resellerId"] = this.resellerId;
        data["accountancyId"] = this.accountancyId;
        data["howDoYouKnowUs"] = this.howDoYouKnowUs;
        data["howDoYouKnowUsExtra"] = this.howDoYouKnowUsExtra;
        data["referral"] = this.referral;
        data["subscriberId"] = this.subscriberId;
        return data;
    }
}

export interface ISubscriberOnboarding {
    id: number;
    name: string;
    email: string;
    date: Date;
    expireDate: Date;
    token: string;
    used: boolean;
    usedDate: Date;
    resellerId: number;
    accountancyId: number;
    howDoYouKnowUs: number;
    howDoYouKnowUsExtra: string;
    referral: string;
    subscriberId: number;
}

export class SubscriberOnboardingInput implements ISubscriberOnboardingInput {
    id!: number;
    name!: string;
    email!: string;
    expirationPeriod!: number;
    accountancyId!: number;
    howDoYouKnowUs!: number;
    howDoYouKnowUsExtra!: string;
    referral!: string;

    constructor(data?: ISubscriberOnboardingInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.expirationPeriod = _data["expirationPeriod"];
            this.accountancyId = _data["accountancyId"];
            this.howDoYouKnowUs = _data["howDoYouKnowUs"];
            this.howDoYouKnowUsExtra = _data["howDoYouKnowUsExtra"];
            this.referral = _data["referral"];
        }
    }

    static fromJS(data: any): SubscriberOnboardingInput {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriberOnboardingInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["expirationPeriod"] = this.expirationPeriod;
        data["accountancyId"] = this.accountancyId;
        data["howDoYouKnowUs"] = this.howDoYouKnowUs;
        data["howDoYouKnowUsExtra"] = this.howDoYouKnowUsExtra;
        data["referral"] = this.referral;
        return data;
    }
}

export interface ISubscriberOnboardingInput {
    id: number;
    name: string;
    email: string;
    expirationPeriod: number;
    accountancyId: number;
    howDoYouKnowUs: number;
    howDoYouKnowUsExtra: string;
    referral: string;
}

export class User implements IUser {
    id!: number;
    subscriber_id!: number;
    defaultSubscriberId!: number;
    mail!: string;
    name!: string;
    phone!: string;
    lastlogin!: Date;
    activated!: boolean;
    created!: Date;
    updated!: Date;
    salt!: string;
    systemCommunications!: boolean;
    accountancyId!: number;
    supportId!: number;
    keyActivation!: string;
    keyPasswordReset!: string;
    hidden!: boolean;
    password!: string;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subscriber_id = _data["subscriber_id"];
            this.defaultSubscriberId = _data["defaultSubscriberId"];
            this.mail = _data["mail"];
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.lastlogin = _data["lastlogin"] ? new Date(_data["lastlogin"].toString()) : <any>undefined;
            this.activated = _data["activated"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
            this.salt = _data["salt"];
            this.systemCommunications = _data["systemCommunications"];
            this.accountancyId = _data["accountancyId"];
            this.supportId = _data["supportId"];
            this.keyActivation = _data["keyActivation"];
            this.keyPasswordReset = _data["keyPasswordReset"];
            this.hidden = _data["hidden"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subscriber_id"] = this.subscriber_id;
        data["defaultSubscriberId"] = this.defaultSubscriberId;
        data["mail"] = this.mail;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["lastlogin"] = this.lastlogin ? this.lastlogin.toISOString() : <any>undefined;
        data["activated"] = this.activated;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["salt"] = this.salt;
        data["systemCommunications"] = this.systemCommunications;
        data["accountancyId"] = this.accountancyId;
        data["supportId"] = this.supportId;
        data["keyActivation"] = this.keyActivation;
        data["keyPasswordReset"] = this.keyPasswordReset;
        data["hidden"] = this.hidden;
        data["password"] = this.password;
        return data;
    }
}

export interface IUser {
    id: number;
    subscriber_id: number;
    defaultSubscriberId: number;
    mail: string;
    name: string;
    phone: string;
    lastlogin: Date;
    activated: boolean;
    created: Date;
    updated: Date;
    salt: string;
    systemCommunications: boolean;
    accountancyId: number;
    supportId: number;
    keyActivation: string;
    keyPasswordReset: string;
    hidden: boolean;
    password: string;
}

export class EntityVatCheck implements IEntityVatCheck {
    valid!: boolean;
    countryCode!: string;
    vatNumber!: string;
    name!: string;
    address!: Address;

    constructor(data?: IEntityVatCheck) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.address = new Address();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valid = _data["valid"];
            this.countryCode = _data["countryCode"];
            this.vatNumber = _data["vatNumber"];
            this.name = _data["name"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : new Address();
        }
    }

    static fromJS(data: any): EntityVatCheck {
        data = typeof data === 'object' ? data : {};
        let result = new EntityVatCheck();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valid"] = this.valid;
        data["countryCode"] = this.countryCode;
        data["vatNumber"] = this.vatNumber;
        data["name"] = this.name;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEntityVatCheck {
    valid: boolean;
    countryCode: string;
    vatNumber: string;
    name: string;
    address: Address;
}

export enum SubscriberTypeEnum {
    _1 = "1",
    _2 = "2",
    _3 = "3",
}

export enum ResellerPaymentTypeEnum {
    _1 = "1",
    _2 = "2",
}

export class Subscriber implements ISubscriber {
    id!: number;
    name!: string;
    vat!: string;
    rpr!: string;
    activated!: boolean;
    created!: Date;
    updated!: Date;
    salt!: string;
    type!: number;
    intigrationOctopusEnabled!: boolean;
    intigrationOctopusLogin!: string;
    intigrationOctopusPassword!: string;
    intigrationOctopusDossierKey!: number;
    intigrationOctopusDescription!: string;
    intigrationOctopusVatNr!: string;
    intigrationOctopusOnlyAccountant!: boolean;
    integrationAdmisolSalesInvoiceMailbox!: string;
    integrationAdmisolPurchaseInvoiceMailbox!: string;
    integrationAdmisolCreditnoteMailbox!: string;
    integrationAdmisolMailboxEnabled!: boolean;
    integrationYukiEnabled!: boolean;
    integrationYukiApiKey!: string;
    integrationYukiAdministrationId!: string;
    integrationIbanityEnabled!: boolean;
    integrationIbanitySupplierId!: string;
    integrationIbanityContact!: string;
    integrationIbanityPassport!: string;
    integrationIbanityHomepage!: string;
    integrationIbanityPhone!: string;
    integrationIbanityReceiver!: boolean;
    integrationIbanityKycCompleted!: boolean;
    integrationExactEnabled!: boolean;
    integrationExactRefreshToken!: string;
    integrationExactAccessToken!: string;
    integrationExactAccessTokenTimestamp!: Date;
    street!: string;
    houseNumber!: string;
    zip!: string;
    city!: string;
    county!: string;
    countryId!: number;
    resellerId!: number;
    accountancyId!: number;
    resellerPaymentType!: number;
    allowAlphaModules!: boolean;
    allowBetaModules!: boolean;
    preferredLicense!: string;
    extraDocuments!: number;
    extraUsers!: number;
    credit!: number;
    autoRenewLicense!: boolean;
    autoRenewLicensePeriod!: number;

    constructor(data?: ISubscriber) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.vat = _data["vat"];
            this.rpr = _data["rpr"];
            this.activated = _data["activated"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
            this.salt = _data["salt"];
            this.type = _data["type"];
            this.intigrationOctopusEnabled = _data["intigrationOctopusEnabled"];
            this.intigrationOctopusLogin = _data["intigrationOctopusLogin"];
            this.intigrationOctopusPassword = _data["intigrationOctopusPassword"];
            this.intigrationOctopusDossierKey = _data["intigrationOctopusDossierKey"];
            this.intigrationOctopusDescription = _data["intigrationOctopusDescription"];
            this.intigrationOctopusVatNr = _data["intigrationOctopusVatNr"];
            this.intigrationOctopusOnlyAccountant = _data["intigrationOctopusOnlyAccountant"];
            this.integrationAdmisolSalesInvoiceMailbox = _data["integrationAdmisolSalesInvoiceMailbox"];
            this.integrationAdmisolPurchaseInvoiceMailbox = _data["integrationAdmisolPurchaseInvoiceMailbox"];
            this.integrationAdmisolCreditnoteMailbox = _data["integrationAdmisolCreditnoteMailbox"];
            this.integrationAdmisolMailboxEnabled = _data["integrationAdmisolMailboxEnabled"];
            this.integrationYukiEnabled = _data["integrationYukiEnabled"];
            this.integrationYukiApiKey = _data["integrationYukiApiKey"];
            this.integrationYukiAdministrationId = _data["integrationYukiAdministrationId"];
            this.integrationIbanityEnabled = _data["integrationIbanityEnabled"];
            this.integrationIbanitySupplierId = _data["integrationIbanitySupplierId"];
            this.integrationIbanityContact = _data["integrationIbanityContact"];
            this.integrationIbanityPassport = _data["integrationIbanityPassport"];
            this.integrationIbanityHomepage = _data["integrationIbanityHomepage"];
            this.integrationIbanityPhone = _data["integrationIbanityPhone"];
            this.integrationIbanityReceiver = _data["integrationIbanityReceiver"];
            this.integrationIbanityKycCompleted = _data["integrationIbanityKycCompleted"];
            this.integrationExactEnabled = _data["integrationExactEnabled"];
            this.integrationExactRefreshToken = _data["integrationExactRefreshToken"];
            this.integrationExactAccessToken = _data["integrationExactAccessToken"];
            this.integrationExactAccessTokenTimestamp = _data["integrationExactAccessTokenTimestamp"] ? new Date(_data["integrationExactAccessTokenTimestamp"].toString()) : <any>undefined;
            this.street = _data["street"];
            this.houseNumber = _data["houseNumber"];
            this.zip = _data["zip"];
            this.city = _data["city"];
            this.county = _data["county"];
            this.countryId = _data["countryId"];
            this.resellerId = _data["resellerId"];
            this.accountancyId = _data["accountancyId"];
            this.resellerPaymentType = _data["resellerPaymentType"];
            this.allowAlphaModules = _data["allowAlphaModules"];
            this.allowBetaModules = _data["allowBetaModules"];
            this.preferredLicense = _data["preferredLicense"];
            this.extraDocuments = _data["extraDocuments"];
            this.extraUsers = _data["extraUsers"];
            this.credit = _data["credit"];
            this.autoRenewLicense = _data["autoRenewLicense"];
            this.autoRenewLicensePeriod = _data["autoRenewLicensePeriod"];
        }
    }

    static fromJS(data: any): Subscriber {
        data = typeof data === 'object' ? data : {};
        let result = new Subscriber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["vat"] = this.vat;
        data["rpr"] = this.rpr;
        data["activated"] = this.activated;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["salt"] = this.salt;
        data["type"] = this.type;
        data["intigrationOctopusEnabled"] = this.intigrationOctopusEnabled;
        data["intigrationOctopusLogin"] = this.intigrationOctopusLogin;
        data["intigrationOctopusPassword"] = this.intigrationOctopusPassword;
        data["intigrationOctopusDossierKey"] = this.intigrationOctopusDossierKey;
        data["intigrationOctopusDescription"] = this.intigrationOctopusDescription;
        data["intigrationOctopusVatNr"] = this.intigrationOctopusVatNr;
        data["intigrationOctopusOnlyAccountant"] = this.intigrationOctopusOnlyAccountant;
        data["integrationAdmisolSalesInvoiceMailbox"] = this.integrationAdmisolSalesInvoiceMailbox;
        data["integrationAdmisolPurchaseInvoiceMailbox"] = this.integrationAdmisolPurchaseInvoiceMailbox;
        data["integrationAdmisolCreditnoteMailbox"] = this.integrationAdmisolCreditnoteMailbox;
        data["integrationAdmisolMailboxEnabled"] = this.integrationAdmisolMailboxEnabled;
        data["integrationYukiEnabled"] = this.integrationYukiEnabled;
        data["integrationYukiApiKey"] = this.integrationYukiApiKey;
        data["integrationYukiAdministrationId"] = this.integrationYukiAdministrationId;
        data["integrationIbanityEnabled"] = this.integrationIbanityEnabled;
        data["integrationIbanitySupplierId"] = this.integrationIbanitySupplierId;
        data["integrationIbanityContact"] = this.integrationIbanityContact;
        data["integrationIbanityPassport"] = this.integrationIbanityPassport;
        data["integrationIbanityHomepage"] = this.integrationIbanityHomepage;
        data["integrationIbanityPhone"] = this.integrationIbanityPhone;
        data["integrationIbanityReceiver"] = this.integrationIbanityReceiver;
        data["integrationIbanityKycCompleted"] = this.integrationIbanityKycCompleted;
        data["integrationExactEnabled"] = this.integrationExactEnabled;
        data["integrationExactRefreshToken"] = this.integrationExactRefreshToken;
        data["integrationExactAccessToken"] = this.integrationExactAccessToken;
        data["integrationExactAccessTokenTimestamp"] = this.integrationExactAccessTokenTimestamp ? this.integrationExactAccessTokenTimestamp.toISOString() : <any>undefined;
        data["street"] = this.street;
        data["houseNumber"] = this.houseNumber;
        data["zip"] = this.zip;
        data["city"] = this.city;
        data["county"] = this.county;
        data["countryId"] = this.countryId;
        data["resellerId"] = this.resellerId;
        data["accountancyId"] = this.accountancyId;
        data["resellerPaymentType"] = this.resellerPaymentType;
        data["allowAlphaModules"] = this.allowAlphaModules;
        data["allowBetaModules"] = this.allowBetaModules;
        data["preferredLicense"] = this.preferredLicense;
        data["extraDocuments"] = this.extraDocuments;
        data["extraUsers"] = this.extraUsers;
        data["credit"] = this.credit;
        data["autoRenewLicense"] = this.autoRenewLicense;
        data["autoRenewLicensePeriod"] = this.autoRenewLicensePeriod;
        return data;
    }
}

export interface ISubscriber {
    id: number;
    name: string;
    vat: string;
    rpr: string;
    activated: boolean;
    created: Date;
    updated: Date;
    salt: string;
    type: number;
    intigrationOctopusEnabled: boolean;
    intigrationOctopusLogin: string;
    intigrationOctopusPassword: string;
    intigrationOctopusDossierKey: number;
    intigrationOctopusDescription: string;
    intigrationOctopusVatNr: string;
    intigrationOctopusOnlyAccountant: boolean;
    integrationAdmisolSalesInvoiceMailbox: string;
    integrationAdmisolPurchaseInvoiceMailbox: string;
    integrationAdmisolCreditnoteMailbox: string;
    integrationAdmisolMailboxEnabled: boolean;
    integrationYukiEnabled: boolean;
    integrationYukiApiKey: string;
    integrationYukiAdministrationId: string;
    integrationIbanityEnabled: boolean;
    integrationIbanitySupplierId: string;
    integrationIbanityContact: string;
    integrationIbanityPassport: string;
    integrationIbanityHomepage: string;
    integrationIbanityPhone: string;
    integrationIbanityReceiver: boolean;
    integrationIbanityKycCompleted: boolean;
    integrationExactEnabled: boolean;
    integrationExactRefreshToken: string;
    integrationExactAccessToken: string;
    integrationExactAccessTokenTimestamp: Date;
    street: string;
    houseNumber: string;
    zip: string;
    city: string;
    county: string;
    countryId: number;
    resellerId: number;
    accountancyId: number;
    resellerPaymentType: number;
    allowAlphaModules: boolean;
    allowBetaModules: boolean;
    preferredLicense: string;
    extraDocuments: number;
    extraUsers: number;
    credit: number;
    autoRenewLicense: boolean;
    autoRenewLicensePeriod: number;
}

export enum DocumentLogoLocation {
    _1 = "1",
    _2 = "2",
    _3 = "3",
    _4 = "4",
}

export enum CompanyPdfNameType {
    _1 = "1",
    _2 = "2",
}

export class Company implements ICompany {
    id!: number;
    subscriber_id!: number;
    number!: number;
    name!: string;
    website!: string;
    phone!: string;
    mail!: string;
    logo!: string;
    created!: Date;
    updated!: Date;
    archived!: boolean;
    default!: boolean;
    defaultBankId!: number;
    termsAndConditions!: string;
    pdfLogoLocation!: number;
    pdfShowBankDetails!: boolean;
    pdfShowBankInPaymentLine!: boolean;
    pdfPaymentLineWithBanks!: boolean;
    pdfShowUnitPrice!: boolean;
    pdfShowInclPrice!: boolean;
    pdfShowSublineDiscount!: boolean;
    pdfShowVatPrice!: boolean;
    pdfDefaultTextTitle!: string;
    pdfDefaultText!: string;
    pdfShowGenerationMessage!: boolean;
    pdfShowGeneratedByMessage!: boolean;
    pdfShowPageNumbers!: boolean;
    pdfShowSalesPersonInformation!: boolean;
    pdfShowContactName!: boolean;
    pdfShowContactEmail!: boolean;
    pdfShowContactPhone!: boolean;
    pdfShowCompanyEmail!: boolean;
    pdfShowCompanyPhone!: boolean;
    pdfShowCompanyWebsite!: boolean;
    pdfShowCompanyName!: boolean;
    pdfShowCompanyAddress!: boolean;
    pdfShowCompanyVat!: boolean;
    pdfShowCompanyRpr!: boolean;
    pdfShowCompanyLegalFooter!: boolean;
    pdfPreviewRaw!: string;
    pdfLogoOpacity!: number;
    pdfNameType!: number;
    pdfShowPayments!: boolean;

    constructor(data?: ICompany) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subscriber_id = _data["subscriber_id"];
            this.number = _data["number"];
            this.name = _data["name"];
            this.website = _data["website"];
            this.phone = _data["phone"];
            this.mail = _data["mail"];
            this.logo = _data["logo"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
            this.archived = _data["archived"];
            this.default = _data["default"];
            this.defaultBankId = _data["defaultBankId"];
            this.termsAndConditions = _data["termsAndConditions"];
            this.pdfLogoLocation = _data["pdfLogoLocation"];
            this.pdfShowBankDetails = _data["pdfShowBankDetails"];
            this.pdfShowBankInPaymentLine = _data["pdfShowBankInPaymentLine"];
            this.pdfPaymentLineWithBanks = _data["pdfPaymentLineWithBanks"];
            this.pdfShowUnitPrice = _data["pdfShowUnitPrice"];
            this.pdfShowInclPrice = _data["pdfShowInclPrice"];
            this.pdfShowSublineDiscount = _data["pdfShowSublineDiscount"];
            this.pdfShowVatPrice = _data["pdfShowVatPrice"];
            this.pdfDefaultTextTitle = _data["pdfDefaultTextTitle"];
            this.pdfDefaultText = _data["pdfDefaultText"];
            this.pdfShowGenerationMessage = _data["pdfShowGenerationMessage"];
            this.pdfShowGeneratedByMessage = _data["pdfShowGeneratedByMessage"];
            this.pdfShowPageNumbers = _data["pdfShowPageNumbers"];
            this.pdfShowSalesPersonInformation = _data["pdfShowSalesPersonInformation"];
            this.pdfShowContactName = _data["pdfShowContactName"];
            this.pdfShowContactEmail = _data["pdfShowContactEmail"];
            this.pdfShowContactPhone = _data["pdfShowContactPhone"];
            this.pdfShowCompanyEmail = _data["pdfShowCompanyEmail"];
            this.pdfShowCompanyPhone = _data["pdfShowCompanyPhone"];
            this.pdfShowCompanyWebsite = _data["pdfShowCompanyWebsite"];
            this.pdfShowCompanyName = _data["pdfShowCompanyName"];
            this.pdfShowCompanyAddress = _data["pdfShowCompanyAddress"];
            this.pdfShowCompanyVat = _data["pdfShowCompanyVat"];
            this.pdfShowCompanyRpr = _data["pdfShowCompanyRpr"];
            this.pdfShowCompanyLegalFooter = _data["pdfShowCompanyLegalFooter"];
            this.pdfPreviewRaw = _data["pdfPreviewRaw"];
            this.pdfLogoOpacity = _data["pdfLogoOpacity"];
            this.pdfNameType = _data["pdfNameType"];
            this.pdfShowPayments = _data["pdfShowPayments"];
        }
    }

    static fromJS(data: any): Company {
        data = typeof data === 'object' ? data : {};
        let result = new Company();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subscriber_id"] = this.subscriber_id;
        data["number"] = this.number;
        data["name"] = this.name;
        data["website"] = this.website;
        data["phone"] = this.phone;
        data["mail"] = this.mail;
        data["logo"] = this.logo;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["archived"] = this.archived;
        data["default"] = this.default;
        data["defaultBankId"] = this.defaultBankId;
        data["termsAndConditions"] = this.termsAndConditions;
        data["pdfLogoLocation"] = this.pdfLogoLocation;
        data["pdfShowBankDetails"] = this.pdfShowBankDetails;
        data["pdfShowBankInPaymentLine"] = this.pdfShowBankInPaymentLine;
        data["pdfPaymentLineWithBanks"] = this.pdfPaymentLineWithBanks;
        data["pdfShowUnitPrice"] = this.pdfShowUnitPrice;
        data["pdfShowInclPrice"] = this.pdfShowInclPrice;
        data["pdfShowSublineDiscount"] = this.pdfShowSublineDiscount;
        data["pdfShowVatPrice"] = this.pdfShowVatPrice;
        data["pdfDefaultTextTitle"] = this.pdfDefaultTextTitle;
        data["pdfDefaultText"] = this.pdfDefaultText;
        data["pdfShowGenerationMessage"] = this.pdfShowGenerationMessage;
        data["pdfShowGeneratedByMessage"] = this.pdfShowGeneratedByMessage;
        data["pdfShowPageNumbers"] = this.pdfShowPageNumbers;
        data["pdfShowSalesPersonInformation"] = this.pdfShowSalesPersonInformation;
        data["pdfShowContactName"] = this.pdfShowContactName;
        data["pdfShowContactEmail"] = this.pdfShowContactEmail;
        data["pdfShowContactPhone"] = this.pdfShowContactPhone;
        data["pdfShowCompanyEmail"] = this.pdfShowCompanyEmail;
        data["pdfShowCompanyPhone"] = this.pdfShowCompanyPhone;
        data["pdfShowCompanyWebsite"] = this.pdfShowCompanyWebsite;
        data["pdfShowCompanyName"] = this.pdfShowCompanyName;
        data["pdfShowCompanyAddress"] = this.pdfShowCompanyAddress;
        data["pdfShowCompanyVat"] = this.pdfShowCompanyVat;
        data["pdfShowCompanyRpr"] = this.pdfShowCompanyRpr;
        data["pdfShowCompanyLegalFooter"] = this.pdfShowCompanyLegalFooter;
        data["pdfPreviewRaw"] = this.pdfPreviewRaw;
        data["pdfLogoOpacity"] = this.pdfLogoOpacity;
        data["pdfNameType"] = this.pdfNameType;
        data["pdfShowPayments"] = this.pdfShowPayments;
        return data;
    }
}

export interface ICompany {
    id: number;
    subscriber_id: number;
    number: number;
    name: string;
    website: string;
    phone: string;
    mail: string;
    logo: string;
    created: Date;
    updated: Date;
    archived: boolean;
    default: boolean;
    defaultBankId: number;
    termsAndConditions: string;
    pdfLogoLocation: number;
    pdfShowBankDetails: boolean;
    pdfShowBankInPaymentLine: boolean;
    pdfPaymentLineWithBanks: boolean;
    pdfShowUnitPrice: boolean;
    pdfShowInclPrice: boolean;
    pdfShowSublineDiscount: boolean;
    pdfShowVatPrice: boolean;
    pdfDefaultTextTitle: string;
    pdfDefaultText: string;
    pdfShowGenerationMessage: boolean;
    pdfShowGeneratedByMessage: boolean;
    pdfShowPageNumbers: boolean;
    pdfShowSalesPersonInformation: boolean;
    pdfShowContactName: boolean;
    pdfShowContactEmail: boolean;
    pdfShowContactPhone: boolean;
    pdfShowCompanyEmail: boolean;
    pdfShowCompanyPhone: boolean;
    pdfShowCompanyWebsite: boolean;
    pdfShowCompanyName: boolean;
    pdfShowCompanyAddress: boolean;
    pdfShowCompanyVat: boolean;
    pdfShowCompanyRpr: boolean;
    pdfShowCompanyLegalFooter: boolean;
    pdfPreviewRaw: string;
    pdfLogoOpacity: number;
    pdfNameType: number;
    pdfShowPayments: boolean;
}

export enum UserEmailTypeEnum {
    _1 = "1",
    _2 = "2",
    _3 = "3",
    _4 = "4",
}

export enum MenuTypeEnum {
    _1 = "1",
    _2 = "2",
}

export class UserSettings implements IUserSettings {
    id!: number;
    subscriber_id!: number;
    user_id!: number;
    language_id!: number;
    tz_id!: number;
    dateFormatDay!: string;
    dateFormatMonth!: string;
    dateFormatYear!: string;
    dateFormatHour!: string;
    dateFormatMinute!: string;
    dateFormatSecond!: string;
    dateSplitSymbol!: string;
    timeSplitSymbol!: string;
    dateFormat!: string;
    timeFormat!: string;
    mailType!: number;
    mailSmtpHost!: string;
    mailSmtpPort!: string;
    mailSmtpSecure!: boolean;
    mailSmtpUser!: string;
    mailSmtpPassword!: string;
    mailGoogleApi!: string;
    mailAzureApi!: string;
    mailSender!: string;
    mailEmail!: string;
    defaultWorkPerformanceServiceId!: number;
    defaultWorkPerformancePrice!: number;
    defaultTranslocationPrice!: number;
    importTranslocationAsOneOnInvoice!: boolean;
    automaticEmailAttachments!: boolean;
    expandPdfOnInvoice!: boolean;
    expandPdfOnOrder!: boolean;
    expandPdfOnQuote!: boolean;
    expandPdfOnReception!: boolean;
    menuType!: number;
    dashboardShowLedgerNumberWarning!: boolean;
    dashboardRevenueChartSizeDesktop!: number;
    dashboardRevenueChartSizeMobile!: number;
    fullWidthBox!: boolean;
    compactSublineView!: boolean;
    mailGoogleLastSynced!: Date;
    mailAzureLastSynced!: Date;

    constructor(data?: IUserSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subscriber_id = _data["subscriber_id"];
            this.user_id = _data["user_id"];
            this.language_id = _data["language_id"];
            this.tz_id = _data["tz_id"];
            this.dateFormatDay = _data["dateFormatDay"];
            this.dateFormatMonth = _data["dateFormatMonth"];
            this.dateFormatYear = _data["dateFormatYear"];
            this.dateFormatHour = _data["dateFormatHour"];
            this.dateFormatMinute = _data["dateFormatMinute"];
            this.dateFormatSecond = _data["dateFormatSecond"];
            this.dateSplitSymbol = _data["dateSplitSymbol"];
            this.timeSplitSymbol = _data["timeSplitSymbol"];
            this.dateFormat = _data["dateFormat"];
            this.timeFormat = _data["timeFormat"];
            this.mailType = _data["mailType"];
            this.mailSmtpHost = _data["mailSmtpHost"];
            this.mailSmtpPort = _data["mailSmtpPort"];
            this.mailSmtpSecure = _data["mailSmtpSecure"];
            this.mailSmtpUser = _data["mailSmtpUser"];
            this.mailSmtpPassword = _data["mailSmtpPassword"];
            this.mailGoogleApi = _data["mailGoogleApi"];
            this.mailAzureApi = _data["mailAzureApi"];
            this.mailSender = _data["mailSender"];
            this.mailEmail = _data["mailEmail"];
            this.defaultWorkPerformanceServiceId = _data["defaultWorkPerformanceServiceId"];
            this.defaultWorkPerformancePrice = _data["defaultWorkPerformancePrice"];
            this.defaultTranslocationPrice = _data["defaultTranslocationPrice"];
            this.importTranslocationAsOneOnInvoice = _data["importTranslocationAsOneOnInvoice"];
            this.automaticEmailAttachments = _data["automaticEmailAttachments"];
            this.expandPdfOnInvoice = _data["expandPdfOnInvoice"];
            this.expandPdfOnOrder = _data["expandPdfOnOrder"];
            this.expandPdfOnQuote = _data["expandPdfOnQuote"];
            this.expandPdfOnReception = _data["expandPdfOnReception"];
            this.menuType = _data["menuType"];
            this.dashboardShowLedgerNumberWarning = _data["dashboardShowLedgerNumberWarning"];
            this.dashboardRevenueChartSizeDesktop = _data["dashboardRevenueChartSizeDesktop"];
            this.dashboardRevenueChartSizeMobile = _data["dashboardRevenueChartSizeMobile"];
            this.fullWidthBox = _data["fullWidthBox"];
            this.compactSublineView = _data["compactSublineView"];
            this.mailGoogleLastSynced = _data["mailGoogleLastSynced"] ? new Date(_data["mailGoogleLastSynced"].toString()) : <any>undefined;
            this.mailAzureLastSynced = _data["mailAzureLastSynced"] ? new Date(_data["mailAzureLastSynced"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserSettings {
        data = typeof data === 'object' ? data : {};
        let result = new UserSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subscriber_id"] = this.subscriber_id;
        data["user_id"] = this.user_id;
        data["language_id"] = this.language_id;
        data["tz_id"] = this.tz_id;
        data["dateFormatDay"] = this.dateFormatDay;
        data["dateFormatMonth"] = this.dateFormatMonth;
        data["dateFormatYear"] = this.dateFormatYear;
        data["dateFormatHour"] = this.dateFormatHour;
        data["dateFormatMinute"] = this.dateFormatMinute;
        data["dateFormatSecond"] = this.dateFormatSecond;
        data["dateSplitSymbol"] = this.dateSplitSymbol;
        data["timeSplitSymbol"] = this.timeSplitSymbol;
        data["dateFormat"] = this.dateFormat;
        data["timeFormat"] = this.timeFormat;
        data["mailType"] = this.mailType;
        data["mailSmtpHost"] = this.mailSmtpHost;
        data["mailSmtpPort"] = this.mailSmtpPort;
        data["mailSmtpSecure"] = this.mailSmtpSecure;
        data["mailSmtpUser"] = this.mailSmtpUser;
        data["mailSmtpPassword"] = this.mailSmtpPassword;
        data["mailGoogleApi"] = this.mailGoogleApi;
        data["mailAzureApi"] = this.mailAzureApi;
        data["mailSender"] = this.mailSender;
        data["mailEmail"] = this.mailEmail;
        data["defaultWorkPerformanceServiceId"] = this.defaultWorkPerformanceServiceId;
        data["defaultWorkPerformancePrice"] = this.defaultWorkPerformancePrice;
        data["defaultTranslocationPrice"] = this.defaultTranslocationPrice;
        data["importTranslocationAsOneOnInvoice"] = this.importTranslocationAsOneOnInvoice;
        data["automaticEmailAttachments"] = this.automaticEmailAttachments;
        data["expandPdfOnInvoice"] = this.expandPdfOnInvoice;
        data["expandPdfOnOrder"] = this.expandPdfOnOrder;
        data["expandPdfOnQuote"] = this.expandPdfOnQuote;
        data["expandPdfOnReception"] = this.expandPdfOnReception;
        data["menuType"] = this.menuType;
        data["dashboardShowLedgerNumberWarning"] = this.dashboardShowLedgerNumberWarning;
        data["dashboardRevenueChartSizeDesktop"] = this.dashboardRevenueChartSizeDesktop;
        data["dashboardRevenueChartSizeMobile"] = this.dashboardRevenueChartSizeMobile;
        data["fullWidthBox"] = this.fullWidthBox;
        data["compactSublineView"] = this.compactSublineView;
        data["mailGoogleLastSynced"] = this.mailGoogleLastSynced ? this.mailGoogleLastSynced.toISOString() : <any>undefined;
        data["mailAzureLastSynced"] = this.mailAzureLastSynced ? this.mailAzureLastSynced.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUserSettings {
    id: number;
    subscriber_id: number;
    user_id: number;
    language_id: number;
    tz_id: number;
    dateFormatDay: string;
    dateFormatMonth: string;
    dateFormatYear: string;
    dateFormatHour: string;
    dateFormatMinute: string;
    dateFormatSecond: string;
    dateSplitSymbol: string;
    timeSplitSymbol: string;
    dateFormat: string;
    timeFormat: string;
    mailType: number;
    mailSmtpHost: string;
    mailSmtpPort: string;
    mailSmtpSecure: boolean;
    mailSmtpUser: string;
    mailSmtpPassword: string;
    mailGoogleApi: string;
    mailAzureApi: string;
    mailSender: string;
    mailEmail: string;
    defaultWorkPerformanceServiceId: number;
    defaultWorkPerformancePrice: number;
    defaultTranslocationPrice: number;
    importTranslocationAsOneOnInvoice: boolean;
    automaticEmailAttachments: boolean;
    expandPdfOnInvoice: boolean;
    expandPdfOnOrder: boolean;
    expandPdfOnQuote: boolean;
    expandPdfOnReception: boolean;
    menuType: number;
    dashboardShowLedgerNumberWarning: boolean;
    dashboardRevenueChartSizeDesktop: number;
    dashboardRevenueChartSizeMobile: number;
    fullWidthBox: boolean;
    compactSublineView: boolean;
    mailGoogleLastSynced: Date;
    mailAzureLastSynced: Date;
}

export class Bank implements IBank {
    id!: number;
    subscriber_id!: number;
    name!: string;
    bic!: string;
    accountnumber!: string;
    created!: Date;
    updated!: Date;
    apiAccount!: string;
    apiRequisition!: string;
    apiBalance!: number;
    apiLastSynced!: Date;
    apiActive!: boolean;
    apiFailedCounter!: number;

    constructor(data?: IBank) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subscriber_id = _data["subscriber_id"];
            this.name = _data["name"];
            this.bic = _data["bic"];
            this.accountnumber = _data["accountnumber"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
            this.apiAccount = _data["apiAccount"];
            this.apiRequisition = _data["apiRequisition"];
            this.apiBalance = _data["apiBalance"];
            this.apiLastSynced = _data["apiLastSynced"] ? new Date(_data["apiLastSynced"].toString()) : <any>undefined;
            this.apiActive = _data["apiActive"];
            this.apiFailedCounter = _data["apiFailedCounter"];
        }
    }

    static fromJS(data: any): Bank {
        data = typeof data === 'object' ? data : {};
        let result = new Bank();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subscriber_id"] = this.subscriber_id;
        data["name"] = this.name;
        data["bic"] = this.bic;
        data["accountnumber"] = this.accountnumber;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["apiAccount"] = this.apiAccount;
        data["apiRequisition"] = this.apiRequisition;
        data["apiBalance"] = this.apiBalance;
        data["apiLastSynced"] = this.apiLastSynced ? this.apiLastSynced.toISOString() : <any>undefined;
        data["apiActive"] = this.apiActive;
        data["apiFailedCounter"] = this.apiFailedCounter;
        return data;
    }
}

export interface IBank {
    id: number;
    subscriber_id: number;
    name: string;
    bic: string;
    accountnumber: string;
    created: Date;
    updated: Date;
    apiAccount: string;
    apiRequisition: string;
    apiBalance: number;
    apiLastSynced: Date;
    apiActive: boolean;
    apiFailedCounter: number;
}

export class CompleteSubscriberOnboarding implements ICompleteSubscriberOnboarding {
    token!: string;
    subscriber!: subscriber;
    company!: Company;
    user!: User;
    userSettings!: UserSettings;
    bank!: Bank;
    password!: string;

    constructor(data?: ICompleteSubscriberOnboarding) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.subscriber = new subscriber();
            this.company = new Company();
            this.user = new User();
            this.userSettings = new UserSettings();
            this.bank = new Bank();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.subscriber = _data["subscriber"] ? subscriber.fromJS(_data["subscriber"]) : new subscriber();
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : new Company();
            this.user = _data["user"] ? User.fromJS(_data["user"]) : new User();
            this.userSettings = _data["userSettings"] ? UserSettings.fromJS(_data["userSettings"]) : new UserSettings();
            this.bank = _data["bank"] ? Bank.fromJS(_data["bank"]) : new Bank();
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): CompleteSubscriberOnboarding {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteSubscriberOnboarding();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["subscriber"] = this.subscriber ? this.subscriber.toJSON() : <any>undefined;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userSettings"] = this.userSettings ? this.userSettings.toJSON() : <any>undefined;
        data["bank"] = this.bank ? this.bank.toJSON() : <any>undefined;
        data["password"] = this.password;
        return data;
    }
}

export interface ICompleteSubscriberOnboarding {
    token: string;
    subscriber: subscriber;
    company: Company;
    user: User;
    userSettings: UserSettings;
    bank: Bank;
    password: string;
}

export class PasswordResetBody implements IPasswordResetBody {
    token!: string;
    id!: number;
    password!: string;

    constructor(data?: IPasswordResetBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.id = _data["id"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): PasswordResetBody {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordResetBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["id"] = this.id;
        data["password"] = this.password;
        return data;
    }
}

export interface IPasswordResetBody {
    token: string;
    id: number;
    password: string;
}

export class CompleteUserOnboardingBody implements ICompleteUserOnboardingBody {
    token!: string;
    id!: number;
    password!: string;

    constructor(data?: ICompleteUserOnboardingBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.id = _data["id"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): CompleteUserOnboardingBody {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteUserOnboardingBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["id"] = this.id;
        data["password"] = this.password;
        return data;
    }
}

export interface ICompleteUserOnboardingBody {
    token: string;
    id: number;
    password: string;
}

export enum InvoiceStatusEnum {
    _1 = "1",
    _2 = "2",
    _3 = "3",
    _4 = "4",
}

export class Transaction implements ITransaction {
    id!: number;
    subscriber_id!: number;
    tbl_obj_id!: number;
    gateway_id!: number;
    gateway_name!: string;
    amount!: number;
    date!: Date;
    note!: string;
    created!: Date;
    updated!: Date;
    bankTransactionId!: number;
    tableId!: number;

    constructor(data?: ITransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subscriber_id = _data["subscriber_id"];
            this.tbl_obj_id = _data["tbl_obj_id"];
            this.gateway_id = _data["gateway_id"];
            this.gateway_name = _data["gateway_name"];
            this.amount = _data["amount"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.note = _data["note"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
            this.bankTransactionId = _data["bankTransactionId"];
            this.tableId = _data["tableId"];
        }
    }

    static fromJS(data: any): Transaction {
        data = typeof data === 'object' ? data : {};
        let result = new Transaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subscriber_id"] = this.subscriber_id;
        data["tbl_obj_id"] = this.tbl_obj_id;
        data["gateway_id"] = this.gateway_id;
        data["gateway_name"] = this.gateway_name;
        data["amount"] = this.amount;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["note"] = this.note;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["bankTransactionId"] = this.bankTransactionId;
        data["tableId"] = this.tableId;
        return data;
    }
}

export interface ITransaction {
    id: number;
    subscriber_id: number;
    tbl_obj_id: number;
    gateway_id: number;
    gateway_name: string;
    amount: number;
    date: Date;
    note: string;
    created: Date;
    updated: Date;
    bankTransactionId: number;
    tableId: number;
}

export enum ArticleTypeEnum {
    _1 = "1",
    _2 = "2",
    _3 = "3",
    _4 = "4",
}

export class InvoiceSubline implements IInvoiceSubline {
    id!: number;
    subscriberId!: number;
    invoiceId!: number;
    accountNumberId!: number;
    note!: string;
    order!: number;
    hideOnPdf!: boolean;
    unit!: string;
    workperformanceId!: number;
    vatCode!: string;
    amount!: number;
    unitPrice!: number;
    basePrice!: number;
    discount!: number;
    price!: number;
    priceIncl!: number;
    vatprice!: number;
    articleSerialNumber!: string;
    articleWarranty!: number;
    created!: Date;
    updated!: Date;
    articleTypeId!: number;
    articleId!: number;
    articleSku!: string;
    articleName!: string;

    constructor(data?: IInvoiceSubline) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subscriberId = _data["subscriberId"];
            this.invoiceId = _data["invoiceId"];
            this.accountNumberId = _data["accountNumberId"];
            this.note = _data["note"];
            this.order = _data["order"];
            this.hideOnPdf = _data["hideOnPdf"];
            this.unit = _data["unit"];
            this.workperformanceId = _data["workperformanceId"];
            this.vatCode = _data["vatCode"];
            this.amount = _data["amount"];
            this.unitPrice = _data["unitPrice"];
            this.basePrice = _data["basePrice"];
            this.discount = _data["discount"];
            this.price = _data["price"];
            this.priceIncl = _data["priceIncl"];
            this.vatprice = _data["vatprice"];
            this.articleSerialNumber = _data["articleSerialNumber"];
            this.articleWarranty = _data["articleWarranty"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
            this.articleTypeId = _data["articleTypeId"];
            this.articleId = _data["articleId"];
            this.articleSku = _data["articleSku"];
            this.articleName = _data["articleName"];
        }
    }

    static fromJS(data: any): InvoiceSubline {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceSubline();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subscriberId"] = this.subscriberId;
        data["invoiceId"] = this.invoiceId;
        data["accountNumberId"] = this.accountNumberId;
        data["note"] = this.note;
        data["order"] = this.order;
        data["hideOnPdf"] = this.hideOnPdf;
        data["unit"] = this.unit;
        data["workperformanceId"] = this.workperformanceId;
        data["vatCode"] = this.vatCode;
        data["amount"] = this.amount;
        data["unitPrice"] = this.unitPrice;
        data["basePrice"] = this.basePrice;
        data["discount"] = this.discount;
        data["price"] = this.price;
        data["priceIncl"] = this.priceIncl;
        data["vatprice"] = this.vatprice;
        data["articleSerialNumber"] = this.articleSerialNumber;
        data["articleWarranty"] = this.articleWarranty;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["articleTypeId"] = this.articleTypeId;
        data["articleId"] = this.articleId;
        data["articleSku"] = this.articleSku;
        data["articleName"] = this.articleName;
        return data;
    }
}

export interface IInvoiceSubline {
    id: number;
    subscriberId: number;
    invoiceId: number;
    accountNumberId: number;
    note: string;
    order: number;
    hideOnPdf: boolean;
    unit: string;
    workperformanceId: number;
    vatCode: string;
    amount: number;
    unitPrice: number;
    basePrice: number;
    discount: number;
    price: number;
    priceIncl: number;
    vatprice: number;
    articleSerialNumber: string;
    articleWarranty: number;
    created: Date;
    updated: Date;
    articleTypeId: number;
    articleId: number;
    articleSku: string;
    articleName: string;
}

export class GuestInvoice implements IGuestInvoice {
    id!: number;
    pdf!: Pdf;
    ubl!: Ubl;
    generalConditions!: GeneralConditions;
    salesInvoiceData!: SalesInvoiceData;

    constructor(data?: IGuestInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pdf = new Pdf();
            this.ubl = new Ubl();
            this.generalConditions = new GeneralConditions();
            this.salesInvoiceData = new SalesInvoiceData();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pdf = _data["pdf"] ? Pdf.fromJS(_data["pdf"]) : new Pdf();
            this.ubl = _data["ubl"] ? Ubl.fromJS(_data["ubl"]) : new Ubl();
            this.generalConditions = _data["generalConditions"] ? GeneralConditions.fromJS(_data["generalConditions"]) : new GeneralConditions();
            this.salesInvoiceData = _data["salesInvoiceData"] ? SalesInvoiceData.fromJS(_data["salesInvoiceData"]) : new SalesInvoiceData();
        }
    }

    static fromJS(data: any): GuestInvoice {
        data = typeof data === 'object' ? data : {};
        let result = new GuestInvoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pdf"] = this.pdf ? this.pdf.toJSON() : <any>undefined;
        data["ubl"] = this.ubl ? this.ubl.toJSON() : <any>undefined;
        data["generalConditions"] = this.generalConditions ? this.generalConditions.toJSON() : <any>undefined;
        data["salesInvoiceData"] = this.salesInvoiceData ? this.salesInvoiceData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGuestInvoice {
    id: number;
    pdf: Pdf;
    ubl: Ubl;
    generalConditions: GeneralConditions;
    salesInvoiceData: SalesInvoiceData;
}

export enum CreditnoteStatusEnum {
    _1 = "1",
    _2 = "2",
    _3 = "3",
    _4 = "4",
}

export class CreditnoteSubline implements ICreditnoteSubline {
    id!: number;
    subscriberId!: number;
    creditnoteId!: number;
    accountNumberId!: number;
    vatCode!: string;
    name!: string;
    note!: string;
    order!: number;
    unit!: string;
    amount!: number;
    unitPrice!: number;
    price!: number;
    priceIncl!: number;
    vatprice!: number;
    created!: Date;
    updated!: Date;

    constructor(data?: ICreditnoteSubline) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subscriberId = _data["subscriberId"];
            this.creditnoteId = _data["creditnoteId"];
            this.accountNumberId = _data["accountNumberId"];
            this.vatCode = _data["vatCode"];
            this.name = _data["name"];
            this.note = _data["note"];
            this.order = _data["order"];
            this.unit = _data["unit"];
            this.amount = _data["amount"];
            this.unitPrice = _data["unitPrice"];
            this.price = _data["price"];
            this.priceIncl = _data["priceIncl"];
            this.vatprice = _data["vatprice"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreditnoteSubline {
        data = typeof data === 'object' ? data : {};
        let result = new CreditnoteSubline();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subscriberId"] = this.subscriberId;
        data["creditnoteId"] = this.creditnoteId;
        data["accountNumberId"] = this.accountNumberId;
        data["vatCode"] = this.vatCode;
        data["name"] = this.name;
        data["note"] = this.note;
        data["order"] = this.order;
        data["unit"] = this.unit;
        data["amount"] = this.amount;
        data["unitPrice"] = this.unitPrice;
        data["price"] = this.price;
        data["priceIncl"] = this.priceIncl;
        data["vatprice"] = this.vatprice;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreditnoteSubline {
    id: number;
    subscriberId: number;
    creditnoteId: number;
    accountNumberId: number;
    vatCode: string;
    name: string;
    note: string;
    order: number;
    unit: string;
    amount: number;
    unitPrice: number;
    price: number;
    priceIncl: number;
    vatprice: number;
    created: Date;
    updated: Date;
}

export class GuestCreditnote implements IGuestCreditnote {
    id!: number;
    pdf!: pdf;
    ubl!: ubl;
    generalConditions!: generalConditions;
    salesCreditnoteData!: SalesCreditnoteData;

    constructor(data?: IGuestCreditnote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pdf = new pdf();
            this.ubl = new ubl();
            this.generalConditions = new generalConditions();
            this.salesCreditnoteData = new SalesCreditnoteData();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pdf = _data["pdf"] ? pdf.fromJS(_data["pdf"]) : new pdf();
            this.ubl = _data["ubl"] ? ubl.fromJS(_data["ubl"]) : new ubl();
            this.generalConditions = _data["generalConditions"] ? generalConditions.fromJS(_data["generalConditions"]) : new generalConditions();
            this.salesCreditnoteData = _data["salesCreditnoteData"] ? SalesCreditnoteData.fromJS(_data["salesCreditnoteData"]) : new SalesCreditnoteData();
        }
    }

    static fromJS(data: any): GuestCreditnote {
        data = typeof data === 'object' ? data : {};
        let result = new GuestCreditnote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pdf"] = this.pdf ? this.pdf.toJSON() : <any>undefined;
        data["ubl"] = this.ubl ? this.ubl.toJSON() : <any>undefined;
        data["generalConditions"] = this.generalConditions ? this.generalConditions.toJSON() : <any>undefined;
        data["salesCreditnoteData"] = this.salesCreditnoteData ? this.salesCreditnoteData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGuestCreditnote {
    id: number;
    pdf: pdf;
    ubl: ubl;
    generalConditions: generalConditions;
    salesCreditnoteData: SalesCreditnoteData;
}

export enum OrderStatusEnum {
    _1 = "1",
    _2 = "2",
    _3 = "3",
    _4 = "4",
}

export class OrderSubline implements IOrderSubline {
    id!: number;
    subscriberId!: number;
    orderId!: number;
    note!: string;
    order!: number;
    unit!: string;
    vatCode!: string;
    amount!: number;
    unitPrice!: number;
    basePrice!: number;
    discount!: number;
    price!: number;
    priceIncl!: number;
    vatprice!: number;
    articleTypeId!: number;
    articleId!: number;
    articleSku!: string;
    articleName!: string;
    created!: Date;
    updated!: Date;

    constructor(data?: IOrderSubline) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subscriberId = _data["subscriberId"];
            this.orderId = _data["orderId"];
            this.note = _data["note"];
            this.order = _data["order"];
            this.unit = _data["unit"];
            this.vatCode = _data["vatCode"];
            this.amount = _data["amount"];
            this.unitPrice = _data["unitPrice"];
            this.basePrice = _data["basePrice"];
            this.discount = _data["discount"];
            this.price = _data["price"];
            this.priceIncl = _data["priceIncl"];
            this.vatprice = _data["vatprice"];
            this.articleTypeId = _data["articleTypeId"];
            this.articleId = _data["articleId"];
            this.articleSku = _data["articleSku"];
            this.articleName = _data["articleName"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderSubline {
        data = typeof data === 'object' ? data : {};
        let result = new OrderSubline();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subscriberId"] = this.subscriberId;
        data["orderId"] = this.orderId;
        data["note"] = this.note;
        data["order"] = this.order;
        data["unit"] = this.unit;
        data["vatCode"] = this.vatCode;
        data["amount"] = this.amount;
        data["unitPrice"] = this.unitPrice;
        data["basePrice"] = this.basePrice;
        data["discount"] = this.discount;
        data["price"] = this.price;
        data["priceIncl"] = this.priceIncl;
        data["vatprice"] = this.vatprice;
        data["articleTypeId"] = this.articleTypeId;
        data["articleId"] = this.articleId;
        data["articleSku"] = this.articleSku;
        data["articleName"] = this.articleName;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        return data;
    }
}

export interface IOrderSubline {
    id: number;
    subscriberId: number;
    orderId: number;
    note: string;
    order: number;
    unit: string;
    vatCode: string;
    amount: number;
    unitPrice: number;
    basePrice: number;
    discount: number;
    price: number;
    priceIncl: number;
    vatprice: number;
    articleTypeId: number;
    articleId: number;
    articleSku: string;
    articleName: string;
    created: Date;
    updated: Date;
}

export class GuestOrder implements IGuestOrder {
    id!: number;
    pdf!: pdf2;
    generalConditions!: generalConditions2;
    salesOrderData!: SalesOrderData;

    constructor(data?: IGuestOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pdf = new pdf2();
            this.generalConditions = new generalConditions2();
            this.salesOrderData = new SalesOrderData();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pdf = _data["pdf"] ? pdf2.fromJS(_data["pdf"]) : new pdf2();
            this.generalConditions = _data["generalConditions"] ? generalConditions2.fromJS(_data["generalConditions"]) : new generalConditions2();
            this.salesOrderData = _data["salesOrderData"] ? SalesOrderData.fromJS(_data["salesOrderData"]) : new SalesOrderData();
        }
    }

    static fromJS(data: any): GuestOrder {
        data = typeof data === 'object' ? data : {};
        let result = new GuestOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pdf"] = this.pdf ? this.pdf.toJSON() : <any>undefined;
        data["generalConditions"] = this.generalConditions ? this.generalConditions.toJSON() : <any>undefined;
        data["salesOrderData"] = this.salesOrderData ? this.salesOrderData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGuestOrder {
    id: number;
    pdf: pdf2;
    generalConditions: generalConditions2;
    salesOrderData: SalesOrderData;
}

export enum QuoteStatusEnum {
    _1 = "1",
    _2 = "2",
    _3 = "3",
    _4 = "4",
    _5 = "5",
}

export class QuoteSubline implements IQuoteSubline {
    id!: number;
    subscriberId!: number;
    quoteId!: number;
    note!: string;
    order!: number;
    unit!: string;
    vatCode!: string;
    amount!: number;
    unitPrice!: number;
    basePrice!: number;
    discount!: number;
    price!: number;
    priceIncl!: number;
    vatprice!: number;
    created!: Date;
    updated!: Date;
    articleTypeId!: number;
    articleId!: number;
    articleSku!: string;
    articleName!: string;

    constructor(data?: IQuoteSubline) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subscriberId = _data["subscriberId"];
            this.quoteId = _data["quoteId"];
            this.note = _data["note"];
            this.order = _data["order"];
            this.unit = _data["unit"];
            this.vatCode = _data["vatCode"];
            this.amount = _data["amount"];
            this.unitPrice = _data["unitPrice"];
            this.basePrice = _data["basePrice"];
            this.discount = _data["discount"];
            this.price = _data["price"];
            this.priceIncl = _data["priceIncl"];
            this.vatprice = _data["vatprice"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
            this.articleTypeId = _data["articleTypeId"];
            this.articleId = _data["articleId"];
            this.articleSku = _data["articleSku"];
            this.articleName = _data["articleName"];
        }
    }

    static fromJS(data: any): QuoteSubline {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteSubline();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subscriberId"] = this.subscriberId;
        data["quoteId"] = this.quoteId;
        data["note"] = this.note;
        data["order"] = this.order;
        data["unit"] = this.unit;
        data["vatCode"] = this.vatCode;
        data["amount"] = this.amount;
        data["unitPrice"] = this.unitPrice;
        data["basePrice"] = this.basePrice;
        data["discount"] = this.discount;
        data["price"] = this.price;
        data["priceIncl"] = this.priceIncl;
        data["vatprice"] = this.vatprice;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["articleTypeId"] = this.articleTypeId;
        data["articleId"] = this.articleId;
        data["articleSku"] = this.articleSku;
        data["articleName"] = this.articleName;
        return data;
    }
}

export interface IQuoteSubline {
    id: number;
    subscriberId: number;
    quoteId: number;
    note: string;
    order: number;
    unit: string;
    vatCode: string;
    amount: number;
    unitPrice: number;
    basePrice: number;
    discount: number;
    price: number;
    priceIncl: number;
    vatprice: number;
    created: Date;
    updated: Date;
    articleTypeId: number;
    articleId: number;
    articleSku: string;
    articleName: string;
}

export class GuestQuote implements IGuestQuote {
    id!: number;
    pdf!: pdf3;
    generalConditions!: generalConditions3;
    salesQuoteData!: SalesQuoteData;

    constructor(data?: IGuestQuote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pdf = new pdf3();
            this.generalConditions = new generalConditions3();
            this.salesQuoteData = new SalesQuoteData();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pdf = _data["pdf"] ? pdf3.fromJS(_data["pdf"]) : new pdf3();
            this.generalConditions = _data["generalConditions"] ? generalConditions3.fromJS(_data["generalConditions"]) : new generalConditions3();
            this.salesQuoteData = _data["salesQuoteData"] ? SalesQuoteData.fromJS(_data["salesQuoteData"]) : new SalesQuoteData();
        }
    }

    static fromJS(data: any): GuestQuote {
        data = typeof data === 'object' ? data : {};
        let result = new GuestQuote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pdf"] = this.pdf ? this.pdf.toJSON() : <any>undefined;
        data["generalConditions"] = this.generalConditions ? this.generalConditions.toJSON() : <any>undefined;
        data["salesQuoteData"] = this.salesQuoteData ? this.salesQuoteData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGuestQuote {
    id: number;
    pdf: pdf3;
    generalConditions: generalConditions3;
    salesQuoteData: SalesQuoteData;
}

export class Quote implements IQuote {
    id!: number;
    subscriberId!: number;
    number!: number;
    isProspect!: boolean;
    value!: number;
    vatValue!: number;
    valueIncl!: number;
    intnote!: string;
    note!: string;
    date!: Date;
    enddate!: Date;
    status!: number;
    guestToken!: string;
    guestEnabled!: boolean;
    signature!: string;
    signatureName!: string;
    guestRemark!: string;
    guestDate!: Date;
    relationReference!: string;
    vatCode!: string;
    companyId!: number;
    companyName!: string;
    companyVatNumber!: string;
    companyAddressStreet!: string;
    companyAddressNumber!: string;
    companyAddressCity!: string;
    companyAddressZip!: string;
    companyAddressCounty!: string;
    companyAddressCountryId!: number;
    created!: Date;
    updated!: Date;
    relationId!: number;
    relationName!: string;
    relationVatNumber!: string;
    relationAddressStreet!: string;
    relationAddressNumber!: string;
    relationAddressCity!: string;
    relationAddressZip!: string;
    relationAddressCounty!: string;
    relationAddressCountryId!: number;
    userId!: number;
    userName!: string;
    userPhone!: string;
    userMail!: string;
    contactId!: number;
    contactName!: string;
    contactPhone!: string;
    contactMail!: string;
    bankName!: string;
    bankAccountNumber!: string;
    bankBic!: string;

    constructor(data?: IQuote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subscriberId = _data["subscriberId"];
            this.number = _data["number"];
            this.isProspect = _data["isProspect"];
            this.value = _data["value"];
            this.vatValue = _data["vatValue"];
            this.valueIncl = _data["valueIncl"];
            this.intnote = _data["intnote"];
            this.note = _data["note"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.enddate = _data["enddate"] ? new Date(_data["enddate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.guestToken = _data["guestToken"];
            this.guestEnabled = _data["guestEnabled"];
            this.signature = _data["signature"];
            this.signatureName = _data["signatureName"];
            this.guestRemark = _data["guestRemark"];
            this.guestDate = _data["guestDate"] ? new Date(_data["guestDate"].toString()) : <any>undefined;
            this.relationReference = _data["relationReference"];
            this.vatCode = _data["vatCode"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.companyVatNumber = _data["companyVatNumber"];
            this.companyAddressStreet = _data["companyAddressStreet"];
            this.companyAddressNumber = _data["companyAddressNumber"];
            this.companyAddressCity = _data["companyAddressCity"];
            this.companyAddressZip = _data["companyAddressZip"];
            this.companyAddressCounty = _data["companyAddressCounty"];
            this.companyAddressCountryId = _data["companyAddressCountryId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
            this.relationId = _data["relationId"];
            this.relationName = _data["relationName"];
            this.relationVatNumber = _data["relationVatNumber"];
            this.relationAddressStreet = _data["relationAddressStreet"];
            this.relationAddressNumber = _data["relationAddressNumber"];
            this.relationAddressCity = _data["relationAddressCity"];
            this.relationAddressZip = _data["relationAddressZip"];
            this.relationAddressCounty = _data["relationAddressCounty"];
            this.relationAddressCountryId = _data["relationAddressCountryId"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.userPhone = _data["userPhone"];
            this.userMail = _data["userMail"];
            this.contactId = _data["contactId"];
            this.contactName = _data["contactName"];
            this.contactPhone = _data["contactPhone"];
            this.contactMail = _data["contactMail"];
            this.bankName = _data["bankName"];
            this.bankAccountNumber = _data["bankAccountNumber"];
            this.bankBic = _data["bankBic"];
        }
    }

    static fromJS(data: any): Quote {
        data = typeof data === 'object' ? data : {};
        let result = new Quote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subscriberId"] = this.subscriberId;
        data["number"] = this.number;
        data["isProspect"] = this.isProspect;
        data["value"] = this.value;
        data["vatValue"] = this.vatValue;
        data["valueIncl"] = this.valueIncl;
        data["intnote"] = this.intnote;
        data["note"] = this.note;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["enddate"] = this.enddate ? this.enddate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["guestToken"] = this.guestToken;
        data["guestEnabled"] = this.guestEnabled;
        data["signature"] = this.signature;
        data["signatureName"] = this.signatureName;
        data["guestRemark"] = this.guestRemark;
        data["guestDate"] = this.guestDate ? this.guestDate.toISOString() : <any>undefined;
        data["relationReference"] = this.relationReference;
        data["vatCode"] = this.vatCode;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["companyVatNumber"] = this.companyVatNumber;
        data["companyAddressStreet"] = this.companyAddressStreet;
        data["companyAddressNumber"] = this.companyAddressNumber;
        data["companyAddressCity"] = this.companyAddressCity;
        data["companyAddressZip"] = this.companyAddressZip;
        data["companyAddressCounty"] = this.companyAddressCounty;
        data["companyAddressCountryId"] = this.companyAddressCountryId;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["relationId"] = this.relationId;
        data["relationName"] = this.relationName;
        data["relationVatNumber"] = this.relationVatNumber;
        data["relationAddressStreet"] = this.relationAddressStreet;
        data["relationAddressNumber"] = this.relationAddressNumber;
        data["relationAddressCity"] = this.relationAddressCity;
        data["relationAddressZip"] = this.relationAddressZip;
        data["relationAddressCounty"] = this.relationAddressCounty;
        data["relationAddressCountryId"] = this.relationAddressCountryId;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["userPhone"] = this.userPhone;
        data["userMail"] = this.userMail;
        data["contactId"] = this.contactId;
        data["contactName"] = this.contactName;
        data["contactPhone"] = this.contactPhone;
        data["contactMail"] = this.contactMail;
        data["bankName"] = this.bankName;
        data["bankAccountNumber"] = this.bankAccountNumber;
        data["bankBic"] = this.bankBic;
        return data;
    }
}

export interface IQuote {
    id: number;
    subscriberId: number;
    number: number;
    isProspect: boolean;
    value: number;
    vatValue: number;
    valueIncl: number;
    intnote: string;
    note: string;
    date: Date;
    enddate: Date;
    status: number;
    guestToken: string;
    guestEnabled: boolean;
    signature: string;
    signatureName: string;
    guestRemark: string;
    guestDate: Date;
    relationReference: string;
    vatCode: string;
    companyId: number;
    companyName: string;
    companyVatNumber: string;
    companyAddressStreet: string;
    companyAddressNumber: string;
    companyAddressCity: string;
    companyAddressZip: string;
    companyAddressCounty: string;
    companyAddressCountryId: number;
    created: Date;
    updated: Date;
    relationId: number;
    relationName: string;
    relationVatNumber: string;
    relationAddressStreet: string;
    relationAddressNumber: string;
    relationAddressCity: string;
    relationAddressZip: string;
    relationAddressCounty: string;
    relationAddressCountryId: number;
    userId: number;
    userName: string;
    userPhone: string;
    userMail: string;
    contactId: number;
    contactName: string;
    contactPhone: string;
    contactMail: string;
    bankName: string;
    bankAccountNumber: string;
    bankBic: string;
}

export enum LedgerExportTypeEnum {
    _1 = "1",
    _2 = "2",
    _3 = "3",
    _4 = "4",
    _5 = "5",
    _6 = "6",
}

export class LedgerExport implements ILedgerExport {
    id!: number;
    subscriberId!: number;
    name!: string;
    userId!: number;
    userName!: string;
    type!: number;
    start!: Date;
    end!: Date;
    salesInvoices!: boolean;
    salesCreditnotes!: boolean;
    purchaseInvoices!: boolean;
    purchaseCreditnotes!: boolean;
    created!: Date;
    started!: Date;
    completed!: Date;
    failed!: Date;
    zipRaw!: string;
    zipExpiration!: Date;
    zipToken!: string;
    zipDownloaded!: Date;

    constructor(data?: ILedgerExport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subscriberId = _data["subscriberId"];
            this.name = _data["name"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.type = _data["type"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.salesInvoices = _data["salesInvoices"];
            this.salesCreditnotes = _data["salesCreditnotes"];
            this.purchaseInvoices = _data["purchaseInvoices"];
            this.purchaseCreditnotes = _data["purchaseCreditnotes"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.started = _data["started"] ? new Date(_data["started"].toString()) : <any>undefined;
            this.completed = _data["completed"] ? new Date(_data["completed"].toString()) : <any>undefined;
            this.failed = _data["failed"] ? new Date(_data["failed"].toString()) : <any>undefined;
            this.zipRaw = _data["zipRaw"];
            this.zipExpiration = _data["zipExpiration"] ? new Date(_data["zipExpiration"].toString()) : <any>undefined;
            this.zipToken = _data["zipToken"];
            this.zipDownloaded = _data["zipDownloaded"] ? new Date(_data["zipDownloaded"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): LedgerExport {
        data = typeof data === 'object' ? data : {};
        let result = new LedgerExport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subscriberId"] = this.subscriberId;
        data["name"] = this.name;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["type"] = this.type;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["salesInvoices"] = this.salesInvoices;
        data["salesCreditnotes"] = this.salesCreditnotes;
        data["purchaseInvoices"] = this.purchaseInvoices;
        data["purchaseCreditnotes"] = this.purchaseCreditnotes;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["started"] = this.started ? this.started.toISOString() : <any>undefined;
        data["completed"] = this.completed ? this.completed.toISOString() : <any>undefined;
        data["failed"] = this.failed ? this.failed.toISOString() : <any>undefined;
        data["zipRaw"] = this.zipRaw;
        data["zipExpiration"] = this.zipExpiration ? this.zipExpiration.toISOString() : <any>undefined;
        data["zipToken"] = this.zipToken;
        data["zipDownloaded"] = this.zipDownloaded ? this.zipDownloaded.toISOString() : <any>undefined;
        return data;
    }
}

export interface ILedgerExport {
    id: number;
    subscriberId: number;
    name: string;
    userId: number;
    userName: string;
    type: number;
    start: Date;
    end: Date;
    salesInvoices: boolean;
    salesCreditnotes: boolean;
    purchaseInvoices: boolean;
    purchaseCreditnotes: boolean;
    created: Date;
    started: Date;
    completed: Date;
    failed: Date;
    zipRaw: string;
    zipExpiration: Date;
    zipToken: string;
    zipDownloaded: Date;
}

export class Token implements IToken {
    id!: number;
    subscriber_id?: number;
    user_id?: number;
    partnerId?: number;
    date!: Date;
    expiration!: Date;
    key!: string;
    ip!: string;

    constructor(data?: IToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subscriber_id = _data["subscriber_id"];
            this.user_id = _data["user_id"];
            this.partnerId = _data["partnerId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.expiration = _data["expiration"] ? new Date(_data["expiration"].toString()) : <any>undefined;
            this.key = _data["key"];
            this.ip = _data["ip"];
        }
    }

    static fromJS(data: any): Token {
        data = typeof data === 'object' ? data : {};
        let result = new Token();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subscriber_id"] = this.subscriber_id;
        data["user_id"] = this.user_id;
        data["partnerId"] = this.partnerId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["expiration"] = this.expiration ? this.expiration.toISOString() : <any>undefined;
        data["key"] = this.key;
        data["ip"] = this.ip;
        return data;
    }
}

export interface IToken {
    id: number;
    subscriber_id?: number;
    user_id?: number;
    partnerId?: number;
    date: Date;
    expiration: Date;
    key: string;
    ip: string;
}

export class Body implements IBody {
    remark!: string;
    signature!: string;
    name!: string;

    [key: string]: any;

    constructor(data?: IBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.remark = _data["remark"];
            this.signature = _data["signature"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Body {
        data = typeof data === 'object' ? data : {};
        let result = new Body();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["remark"] = this.remark;
        data["signature"] = this.signature;
        data["name"] = this.name;
        return data;
    }
}

export interface IBody {
    remark: string;
    signature: string;
    name: string;

    [key: string]: any;
}

export class Body2 implements IBody2 {
    remark!: string;
    signature!: string;
    name!: string;

    [key: string]: any;

    constructor(data?: IBody2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.remark = _data["remark"];
            this.signature = _data["signature"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Body2 {
        data = typeof data === 'object' ? data : {};
        let result = new Body2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["remark"] = this.remark;
        data["signature"] = this.signature;
        data["name"] = this.name;
        return data;
    }
}

export interface IBody2 {
    remark: string;
    signature: string;
    name: string;

    [key: string]: any;
}

export class Anonymous implements IAnonymous {
    settings!: any;
    name!: string;
    id!: number;

    [key: string]: any;

    constructor(data?: IAnonymous) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.settings = _data["settings"];
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Anonymous {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["settings"] = this.settings;
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface IAnonymous {
    settings: any;
    name: string;
    id: number;

    [key: string]: any;
}

export class Address implements IAddress {
    countryCode!: string;
    city!: string;
    zip_code!: string;
    number!: number;
    street!: string;

    [key: string]: any;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.countryCode = _data["countryCode"];
            this.city = _data["city"];
            this.zip_code = _data["zip_code"];
            this.number = _data["number"];
            this.street = _data["street"];
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["countryCode"] = this.countryCode;
        data["city"] = this.city;
        data["zip_code"] = this.zip_code;
        data["number"] = this.number;
        data["street"] = this.street;
        return data;
    }
}

export interface IAddress {
    countryCode: string;
    city: string;
    zip_code: string;
    number: number;
    street: string;

    [key: string]: any;
}

export class subscriber implements Isubscriber {
    type!: number;
    accountancyId!: number;
    resellerId!: number;
    countryId!: number;
    county!: string;
    zip!: string;
    city!: string;
    houseNumber!: string;
    street!: string;
    rpr!: string;
    vat!: string;
    name!: string;

    [key: string]: any;

    constructor(data?: Isubscriber) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.accountancyId = _data["accountancyId"];
            this.resellerId = _data["resellerId"];
            this.countryId = _data["countryId"];
            this.county = _data["county"];
            this.zip = _data["zip"];
            this.city = _data["city"];
            this.houseNumber = _data["houseNumber"];
            this.street = _data["street"];
            this.rpr = _data["rpr"];
            this.vat = _data["vat"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): subscriber {
        data = typeof data === 'object' ? data : {};
        let result = new subscriber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["accountancyId"] = this.accountancyId;
        data["resellerId"] = this.resellerId;
        data["countryId"] = this.countryId;
        data["county"] = this.county;
        data["zip"] = this.zip;
        data["city"] = this.city;
        data["houseNumber"] = this.houseNumber;
        data["street"] = this.street;
        data["rpr"] = this.rpr;
        data["vat"] = this.vat;
        data["name"] = this.name;
        return data;
    }
}

export interface Isubscriber {
    type: number;
    accountancyId: number;
    resellerId: number;
    countryId: number;
    county: string;
    zip: string;
    city: string;
    houseNumber: string;
    street: string;
    rpr: string;
    vat: string;
    name: string;

    [key: string]: any;
}

export class Pdf implements IPdf {
    raw!: string;
    name!: string;
    included!: boolean;

    [key: string]: any;

    constructor(data?: IPdf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.raw = _data["raw"];
            this.name = _data["name"];
            this.included = _data["included"];
        }
    }

    static fromJS(data: any): Pdf {
        data = typeof data === 'object' ? data : {};
        let result = new Pdf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["raw"] = this.raw;
        data["name"] = this.name;
        data["included"] = this.included;
        return data;
    }
}

export interface IPdf {
    raw: string;
    name: string;
    included: boolean;

    [key: string]: any;
}

export class Ubl implements IUbl {
    raw!: string;
    name!: string;
    included!: boolean;

    [key: string]: any;

    constructor(data?: IUbl) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.raw = _data["raw"];
            this.name = _data["name"];
            this.included = _data["included"];
        }
    }

    static fromJS(data: any): Ubl {
        data = typeof data === 'object' ? data : {};
        let result = new Ubl();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["raw"] = this.raw;
        data["name"] = this.name;
        data["included"] = this.included;
        return data;
    }
}

export interface IUbl {
    raw: string;
    name: string;
    included: boolean;

    [key: string]: any;
}

export class GeneralConditions implements IGeneralConditions {
    raw!: string;
    included!: boolean;

    [key: string]: any;

    constructor(data?: IGeneralConditions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.raw = _data["raw"];
            this.included = _data["included"];
        }
    }

    static fromJS(data: any): GeneralConditions {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralConditions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["raw"] = this.raw;
        data["included"] = this.included;
        return data;
    }
}

export interface IGeneralConditions {
    raw: string;
    included: boolean;

    [key: string]: any;
}

export class SalesInvoiceData implements ISalesInvoiceData {
    number!: string;
    sublines!: InvoiceSubline[];
    transactions!: Transaction[];
    paymentReference!: string;
    bic!: string;
    iban!: string;
    status!: number;
    valueIncl!: number;
    valueVat!: number;
    valueExcl!: number;

    [key: string]: any;

    constructor(data?: ISalesInvoiceData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sublines = [];
            this.transactions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.number = _data["number"];
            if (Array.isArray(_data["sublines"])) {
                this.sublines = [] as any;
                for (let item of _data["sublines"])
                    this.sublines!.push(InvoiceSubline.fromJS(item));
            }
            if (Array.isArray(_data["transactions"])) {
                this.transactions = [] as any;
                for (let item of _data["transactions"])
                    this.transactions!.push(Transaction.fromJS(item));
            }
            this.paymentReference = _data["paymentReference"];
            this.bic = _data["bic"];
            this.iban = _data["iban"];
            this.status = _data["status"];
            this.valueIncl = _data["valueIncl"];
            this.valueVat = _data["valueVat"];
            this.valueExcl = _data["valueExcl"];
        }
    }

    static fromJS(data: any): SalesInvoiceData {
        data = typeof data === 'object' ? data : {};
        let result = new SalesInvoiceData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["number"] = this.number;
        if (Array.isArray(this.sublines)) {
            data["sublines"] = [];
            for (let item of this.sublines)
                data["sublines"].push(item.toJSON());
        }
        if (Array.isArray(this.transactions)) {
            data["transactions"] = [];
            for (let item of this.transactions)
                data["transactions"].push(item.toJSON());
        }
        data["paymentReference"] = this.paymentReference;
        data["bic"] = this.bic;
        data["iban"] = this.iban;
        data["status"] = this.status;
        data["valueIncl"] = this.valueIncl;
        data["valueVat"] = this.valueVat;
        data["valueExcl"] = this.valueExcl;
        return data;
    }
}

export interface ISalesInvoiceData {
    number: string;
    sublines: InvoiceSubline[];
    transactions: Transaction[];
    paymentReference: string;
    bic: string;
    iban: string;
    status: number;
    valueIncl: number;
    valueVat: number;
    valueExcl: number;

    [key: string]: any;
}

export class pdf implements Ipdf {
    raw!: string;
    name!: string;
    included!: boolean;

    [key: string]: any;

    constructor(data?: Ipdf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.raw = _data["raw"];
            this.name = _data["name"];
            this.included = _data["included"];
        }
    }

    static fromJS(data: any): pdf {
        data = typeof data === 'object' ? data : {};
        let result = new pdf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["raw"] = this.raw;
        data["name"] = this.name;
        data["included"] = this.included;
        return data;
    }
}

export interface Ipdf {
    raw: string;
    name: string;
    included: boolean;

    [key: string]: any;
}

export class ubl implements Iubl {
    raw!: string;
    name!: string;
    included!: boolean;

    [key: string]: any;

    constructor(data?: Iubl) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.raw = _data["raw"];
            this.name = _data["name"];
            this.included = _data["included"];
        }
    }

    static fromJS(data: any): ubl {
        data = typeof data === 'object' ? data : {};
        let result = new ubl();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["raw"] = this.raw;
        data["name"] = this.name;
        data["included"] = this.included;
        return data;
    }
}

export interface Iubl {
    raw: string;
    name: string;
    included: boolean;

    [key: string]: any;
}

export class generalConditions implements IgeneralConditions {
    raw!: string;
    included!: boolean;

    [key: string]: any;

    constructor(data?: IgeneralConditions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.raw = _data["raw"];
            this.included = _data["included"];
        }
    }

    static fromJS(data: any): generalConditions {
        data = typeof data === 'object' ? data : {};
        let result = new generalConditions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["raw"] = this.raw;
        data["included"] = this.included;
        return data;
    }
}

export interface IgeneralConditions {
    raw: string;
    included: boolean;

    [key: string]: any;
}

export class SalesCreditnoteData implements ISalesCreditnoteData {
    number!: string;
    sublines!: CreditnoteSubline[];
    transactions!: Transaction[];
    status!: number;
    valueIncl!: number;
    valueVat!: number;
    valueExcl!: number;

    [key: string]: any;

    constructor(data?: ISalesCreditnoteData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sublines = [];
            this.transactions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.number = _data["number"];
            if (Array.isArray(_data["sublines"])) {
                this.sublines = [] as any;
                for (let item of _data["sublines"])
                    this.sublines!.push(CreditnoteSubline.fromJS(item));
            }
            if (Array.isArray(_data["transactions"])) {
                this.transactions = [] as any;
                for (let item of _data["transactions"])
                    this.transactions!.push(Transaction.fromJS(item));
            }
            this.status = _data["status"];
            this.valueIncl = _data["valueIncl"];
            this.valueVat = _data["valueVat"];
            this.valueExcl = _data["valueExcl"];
        }
    }

    static fromJS(data: any): SalesCreditnoteData {
        data = typeof data === 'object' ? data : {};
        let result = new SalesCreditnoteData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["number"] = this.number;
        if (Array.isArray(this.sublines)) {
            data["sublines"] = [];
            for (let item of this.sublines)
                data["sublines"].push(item.toJSON());
        }
        if (Array.isArray(this.transactions)) {
            data["transactions"] = [];
            for (let item of this.transactions)
                data["transactions"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["valueIncl"] = this.valueIncl;
        data["valueVat"] = this.valueVat;
        data["valueExcl"] = this.valueExcl;
        return data;
    }
}

export interface ISalesCreditnoteData {
    number: string;
    sublines: CreditnoteSubline[];
    transactions: Transaction[];
    status: number;
    valueIncl: number;
    valueVat: number;
    valueExcl: number;

    [key: string]: any;
}

export class pdf2 implements Ipdf2 {
    raw!: string;
    name!: string;
    included!: boolean;

    [key: string]: any;

    constructor(data?: Ipdf2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.raw = _data["raw"];
            this.name = _data["name"];
            this.included = _data["included"];
        }
    }

    static fromJS(data: any): pdf2 {
        data = typeof data === 'object' ? data : {};
        let result = new pdf2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["raw"] = this.raw;
        data["name"] = this.name;
        data["included"] = this.included;
        return data;
    }
}

export interface Ipdf2 {
    raw: string;
    name: string;
    included: boolean;

    [key: string]: any;
}

export class generalConditions2 implements IgeneralConditions2 {
    raw!: string;
    included!: boolean;

    [key: string]: any;

    constructor(data?: IgeneralConditions2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.raw = _data["raw"];
            this.included = _data["included"];
        }
    }

    static fromJS(data: any): generalConditions2 {
        data = typeof data === 'object' ? data : {};
        let result = new generalConditions2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["raw"] = this.raw;
        data["included"] = this.included;
        return data;
    }
}

export interface IgeneralConditions2 {
    raw: string;
    included: boolean;

    [key: string]: any;
}

export class SalesOrderData implements ISalesOrderData {
    number!: string;
    sublines!: OrderSubline[];
    status!: number;
    valueIncl!: number;
    valueVat!: number;
    valueExcl!: number;

    [key: string]: any;

    constructor(data?: ISalesOrderData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sublines = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.number = _data["number"];
            if (Array.isArray(_data["sublines"])) {
                this.sublines = [] as any;
                for (let item of _data["sublines"])
                    this.sublines!.push(OrderSubline.fromJS(item));
            }
            this.status = _data["status"];
            this.valueIncl = _data["valueIncl"];
            this.valueVat = _data["valueVat"];
            this.valueExcl = _data["valueExcl"];
        }
    }

    static fromJS(data: any): SalesOrderData {
        data = typeof data === 'object' ? data : {};
        let result = new SalesOrderData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["number"] = this.number;
        if (Array.isArray(this.sublines)) {
            data["sublines"] = [];
            for (let item of this.sublines)
                data["sublines"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["valueIncl"] = this.valueIncl;
        data["valueVat"] = this.valueVat;
        data["valueExcl"] = this.valueExcl;
        return data;
    }
}

export interface ISalesOrderData {
    number: string;
    sublines: OrderSubline[];
    status: number;
    valueIncl: number;
    valueVat: number;
    valueExcl: number;

    [key: string]: any;
}

export class pdf3 implements Ipdf3 {
    raw!: string;
    name!: string;
    included!: boolean;

    [key: string]: any;

    constructor(data?: Ipdf3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.raw = _data["raw"];
            this.name = _data["name"];
            this.included = _data["included"];
        }
    }

    static fromJS(data: any): pdf3 {
        data = typeof data === 'object' ? data : {};
        let result = new pdf3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["raw"] = this.raw;
        data["name"] = this.name;
        data["included"] = this.included;
        return data;
    }
}

export interface Ipdf3 {
    raw: string;
    name: string;
    included: boolean;

    [key: string]: any;
}

export class generalConditions3 implements IgeneralConditions3 {
    raw!: string;
    included!: boolean;

    [key: string]: any;

    constructor(data?: IgeneralConditions3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.raw = _data["raw"];
            this.included = _data["included"];
        }
    }

    static fromJS(data: any): generalConditions3 {
        data = typeof data === 'object' ? data : {};
        let result = new generalConditions3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["raw"] = this.raw;
        data["included"] = this.included;
        return data;
    }
}

export interface IgeneralConditions3 {
    raw: string;
    included: boolean;

    [key: string]: any;
}

export class SalesQuoteData implements ISalesQuoteData {
    number!: string;
    sublines!: QuoteSubline[];
    status!: number;
    valueIncl!: number;
    valueVat!: number;
    valueExcl!: number;
    date!: Date;
    name!: string;
    completed!: boolean;

    [key: string]: any;

    constructor(data?: ISalesQuoteData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sublines = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.number = _data["number"];
            if (Array.isArray(_data["sublines"])) {
                this.sublines = [] as any;
                for (let item of _data["sublines"])
                    this.sublines!.push(QuoteSubline.fromJS(item));
            }
            this.status = _data["status"];
            this.valueIncl = _data["valueIncl"];
            this.valueVat = _data["valueVat"];
            this.valueExcl = _data["valueExcl"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.completed = _data["completed"];
        }
    }

    static fromJS(data: any): SalesQuoteData {
        data = typeof data === 'object' ? data : {};
        let result = new SalesQuoteData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["number"] = this.number;
        if (Array.isArray(this.sublines)) {
            data["sublines"] = [];
            for (let item of this.sublines)
                data["sublines"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["valueIncl"] = this.valueIncl;
        data["valueVat"] = this.valueVat;
        data["valueExcl"] = this.valueExcl;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["completed"] = this.completed;
        return data;
    }
}

export interface ISalesQuoteData {
    number: string;
    sublines: QuoteSubline[];
    status: number;
    valueIncl: number;
    valueVat: number;
    valueExcl: number;
    date: Date;
    name: string;
    completed: boolean;

    [key: string]: any;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}